module.exports = __webpack_public_path__ + "static/media/newEdit.1f4631a2.svg";